import { encrypt as baseEncrypt } from '@packages/crypto';

const encryptKey = process.env.NEXT_PUBLIC_BODY_ENCRYPT_KEY || '';

export const encrypt = (values: string): string => {
  return baseEncrypt(values, encryptKey);
};
